export type ProfileQuestionBlock = {
  section: string;
  questionText: string;
};

export type QuestionLike = {
  section?: string;
  questionText?: string;
  question?: string;
  questionItems?: Array<{ section?: string; questionText?: string; question?: string }>;
};

export function expandProfileQuestionBlocks(source: QuestionLike): ProfileQuestionBlock[] {
  const rawItems = source.questionItems;
  if (Array.isArray(rawItems) && rawItems.length > 0) {
    return rawItems
      .map((item) => ({
        section: String(item.section || source.section || 'General').trim() || 'General',
        questionText: String(item.questionText || item.question || '').trim(),
      }))
      .filter((item) => item.questionText);
  }

  const section = String(source.section || 'General').trim() || 'General';
  const text = String(source.questionText || source.question || '').trim();
  if (!text) return [];

  const splitParts = (value: string) => {
    if (value.includes('\n\n---\n\n')) {
      return value
        .split('\n\n---\n\n')
        .map((part) => part.trim())
        .filter(Boolean);
    }
    if (value.includes('\n---\n')) {
      return value
        .split('\n---\n')
        .map((part) => part.trim())
        .filter(Boolean);
    }
    if (value.includes(' --- ')) {
      return value
        .split(/\s+---\s+/)
        .map((part) => part.trim())
        .filter(Boolean);
    }
    return [value];
  };

  return splitParts(text).map((part) => {
    const sectionMatch = part.match(/^([^:\n]{2,80}):\s*(.+)$/s);
    if (sectionMatch) {
      return {
        section: sectionMatch[1].trim() || section,
        questionText: sectionMatch[2].trim(),
      };
    }
    return { section, questionText: part };
  });
}

export function groupProfileQuestionBlocks(
  blocks: ProfileQuestionBlock[]
): Record<string, ProfileQuestionBlock[]> {
  return blocks.reduce<Record<string, ProfileQuestionBlock[]>>((groups, block) => {
    const key = block.section || 'General';
    if (!groups[key]) groups[key] = [];
    groups[key].push(block);
    return groups;
  }, {});
}
